export const enum CurrentEnvironment {
  DEV = 'dev',
  PROD = 'prod',
  STAGE = 'stage',
}

export const enum RequestMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  OPTIONS = 'OPTIONS',
  PATCH = 'PATCH',
}

export const EMAIL_REGEXP =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const enum EventLoggerInstanceName {
  GIA = 'gia-amplitude',
  AMPLITUDE = 'amplitude',
  USER_FLOW_TRACKER = 'user-flow-tracker',
}

export const enum PlatformOS {
  ANDROID = 'Android',
  IOS = 'iOS',
  UNKNOWN = 'unknown',
}

export const SubscriptionListType = {
  PURCHASE: 'purchase',
  UPSELL: 'upsell',
  SECONDARY: 'secondary',
  ONE_TIME: 'one_time',
} as const

export const enum SubscriptionTag {
  NO_TAX = 'no_tax',
  NO_TAX_EUR = 'no_tax_eur',
  CANCEL_OFFER = 'cancel',
  US = 'us',
  US_TEST = 'us_test',
  EN = 'en',
  BR = 'br',
  MX = 'mx',
  TR = 'tr',
  TOGGLE = 'toggle',
  TRIAL = 'trial',
  RECURRING_US = 'recurring_us',
  ONE_TIME_US = 'one_time_us',
}

export const enum ProductKey {
  ONE_WEEK = 'oneWeek',
  ONE_WEEK_SOULDOUT = 'oneWeek_soldout',
}

export const enum Cohort {
  BIOLOGY = 'biology-bau',
  ANATOMY = 'anatomy-bau',
  ANATOMY_EXT = 'anatomy-bau-ext',
  ANATOMY_V2 = 'anatomy-v2-bau',
  ANATOMY_ALT = 'anatomy-bau-alt',
  HISTORY = 'history-bau',
  COMMUNICATION = 'communication-bau',
  ART = 'art-bau',
  GENERAL = 'general-bau',
}

export const enum TimeInterval {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  ONCE = 'once',
}

export const TEST_ENV_QUERY_PARAM = 'is_test_environment'
export const APP_NAME = 'mygrowth'

export const CENTS_IN_DOLLAR = 100
export const INITIAL_PRICE = 0

export const enum PlanAddition {
  UPSELL = 'Upsell',
}

export const enum OptionType {
  RADIO = 'radio',
  CHECKBOX = 'checkbox',
}

export const enum TrialPeriod {
  ONE_DAY = 1,
  THREE_DAY = 3,
  ONE_WEEK = 7,
  ONE_MONTH = 30,
  TWO_MONTH = 60,
  THREE_MONTH = 90,
  SIX_MONTH_IN_DAYS = 180,
  SIX_MONTH = 6,
  ONE_YEAR = 365,
}

export const TRIAL_DESCRIPTION_CONTEXT = {
  [TrialPeriod.ONE_WEEK]: 'week',
  [TrialPeriod.ONE_MONTH]: 'month',
  [TrialPeriod.TWO_MONTH]: 'two_months',
  [TrialPeriod.THREE_MONTH]: 'quarter',
  [TrialPeriod.SIX_MONTH_IN_DAYS]: 'half_year',
  [TrialPeriod.SIX_MONTH]: 'half_year_week_trial',
  [TrialPeriod.ONE_YEAR]: 'one_year',
}

export const FEATURE_KEYS = {
  fas_1379_primer_paypal: 'fas_1379_primer_paypal',
  fas_1534_primer_card: 'fas-1534-primer-card',
  fas_1550_card_preselected: 'fas_1550_card_preselected',
  myg_1154_subscription_v2: 'myg_1154_subscription_v2',
  anatomy_paywall_version: 'anatomy_paywall_version',
  upsell_one_time: 'upsell_one_time',
  new_price_us: 'new_price_us',
  new_price_en: 'new_price_en',
  new_price_br: 'new_price_br',
  new_price_mx: 'new_price_mx',
  new_price_tr: 'new_price_tr',
  upsell_v3_anatomy_en: 'upsell_v3_anatomy_en',
  upcell: 'upcell',
  direct_stripe_payment: 'direct_stripe_payment',
  price_europe_eur: 'price_europe_eur',
  paypal_hide: 'paypal_hide',
  login_before_upsell: 'login_before_upsell',
} as const

export const EXPERIMENT_ID_NOT_SET = 'experiment_id_not_set'
export const NO_GROWTH_BOOK_TEST = 'no_test'
export const SUPPORT_EMAIL = 'support@mygrowth.one'
export const CDN_FOLDER_LINK =
  'https://cdn-prod-unified-content.gismart.xyz/e4dafa85335ee54842678a907f10f8bc898e506355d67a316bbb25ae96c46595'

export const STORE_DEEP_LINK =
  'https://mygrowth.onelink.me/As4s?af_xp=custom&pid=web2wave&deep_link_value=custom_token'
export const APP_STORE_PPID = '2f04dc8b-e9b5-48fc-b182-71583029054d'
